export default __webpack_public_path__ + "static/media/P22UndergroundBook.ce6f8eaf.ttf";